<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner variant="secondary" type="grow" />
    </div>
    <div v-else>
      <b-container class="max-width pb-4" fluid="">
        <title-back-button
          :title="trans('webinars.dashboard.title')"
          :show-breadcrumbs="true"
          :current-page="trans('webinars.dashboard.title')"
          :prev-page="trans('global.back')"
          :prev-page-link="{ name: 'webinar' }"
        />

        <div class="text-center" v-if="!webinar.master || !webinar.master.moduleCompleted">
          <b-img fluid :src="banner" />
        </div>

        <b-card body-class="light-background py-4" class="shadowed" v-else>
          <div class="row justify-content-center mx-0">
            <div class="col-12 col-md-10 text-center">
              <b-img fluid src="/images/end-of-master-illustration.svg" class="completedImg" />
              <h3 class="text-primary">{{ trans("webinars.detail.completed.title") }}</h3>
              <p>{{ trans("webinars.detail.completed.description") }}</p>
              <b-button variant="secondary" :to="parseNav(webinar.master.certificateNav)">{{
                trans("webinars.detail.completed.cta")
              }}</b-button>
            </div>
          </div>
        </b-card>

        <webinar-session-card
          :webinar="webinar"
          v-if="!webinar.anySessionPassed || !webinar.augmented"
        />

        <vertical-stepper
          :steps="webinar.stepData.steps"
          :current-step="webinar.stepData.currentStep"
          v-if="webinar.stepData"
        />
      </b-container>

      <div class="light-background py-5" v-if="webinar.videoLink">
        <b-container fluid="" class="max-width text-center">
          <div class="row justify-content-center">
            <div class="col-12" :class="contentWidthClass">
              <h5 class="text-primary">{{ trans("webinars.detail.teaser_title") }}</h5>
              <p>{{ trans("webinars.detail.teaser_desc") }}</p>
              <div class="my-4">
                <b-embed
                  type="iframe"
                  aspect="16by9"
                  :src="webinar.videoLink"
                  allowfullscreen
                  sandbox="allow-scripts allow-same-origin allow-presentation"
                ></b-embed>
              </div>
            </div>
          </div>
        </b-container>
      </div>
      <b-container fluid="" class="max-width py-5" v-if="webinar.more">
        <div class="row justify-content-center">
          <div class="col-12" :class="contentWidthClass">
            <h5 class="text-primary">{{ trans("webinars.detail.content_title") }}</h5>
            <div v-html="webinar.more" />
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import TitleBackButton from "../../molecules/TitleBackButton";
import WebinarSessionCard from "./WebinarSessionCard";
import VerticalStepper from "../VerticalStepper";
import navMixin from "../../mixins/navMixin";

export default {
  name: "WebinarDetail",
  components: { TitleBackButton, WebinarSessionCard, VerticalStepper },
  data() {
    return {
      webinar: {},
      loading: true,
    };
  },
  mounted() {
    trackEvent("ReachDetailView", {
      "webinar-id": this.$route.params.id,
    });
    this.$axios
      .get(`/api/rest/webinar/${this.$route.params.id}`)
      .then((res) => {
        this.webinar = res.data.webinar;
        this.loading = false;
      })
      .catch((err) => {
        console.log(err);
        this.loading = false;
      });
  },
  computed: {
    sessionClass() {
      return this.webinar.augmented ? "col-md-6" : "col-md-10";
    },
    contentWidthClass() {
      return this.webinar.augmented ? "" : "col-md-10";
    },
    banner() {
      return this.webinar.banner ? this.webinar.banner : "/images/webinars/default-banner.png";
    },
  },
  mixins: [navMixin],
};
</script>

<style scoped lang="scss">
.webinar-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
}

.light-background {
  background-color: $color-light;
}

.completedImg {
  height: 360px;
  width: 360px;
}
</style>
